module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/_wales-63a9d372e2c94f93d89ccfcfe77ac4f6.png";